import { DocumentSnapshot } from '@firebase/firestore-types';

import * as uuid from 'uuid';
import * as moment from 'moment';

export class Member {
  public static of(s:DocumentSnapshot):Member{
    return {
      id: s.id,
      data: s.data() as MemberData,
      _snapshot: s
    }
  }

  id:string;
  data: MemberData;
  _snapshot: DocumentSnapshot;
};

export class MemberData{
    uuid: string;
    created_at: Date;
    updated_at?: Date;
    deleted_at?: Date;
    email_validated: boolean;
    code: string;
    title: string;
    last_name: string;
    first_name: string;
    address1: string;
    address2?: string;
    post_code: string;
    city: string;
    phone1: string;
    phone2: string;
    medical_certificate_date?: Date;
    cardSent?: Date;
    image_permission: boolean;
    email?: string;
    source: SourceEnum;
    membership_date: Date;
    family: FamilyEnum;
    member_type: MemberTypeEnum;
    board_position: BoardPositionEnum;
    coach: boolean;
    gender: GenderEnum;
    birthdate: Date;
    payment?: PaymentEnum;
    paymentType?: PaymentTypeEnum;
    seasons?: string[];

    private static boardPosition(v: string): BoardPositionEnum{
      return null;
    }

    static from(row:string[]):MemberData{
      return Object.assign(new MemberData(), {
        uuid: uuid.v4(),
        created_at: new Date(),
        email_validated: false,
        code: row[0],
        title: row[1],
        last_name: row[2],
        first_name: row[3],
        address1: row[4],
        address2: row[5],
        post_code: row[6],
        city: row[7],
        phone1: row[8] && row[8].length>2?row[8]:row[9],
        phone2: row[8] && row[8].length>2 && row[9].length>2?row[9]:null,
        medical_certificate_date: moment(row[10], 'DD MM YYYY').toDate(),
        image_permission: row[11]=='X',
        email: row[12],
        source: row[13]?SourceEnum.old:SourceEnum.new,
        membership_date: moment(row[14], 'DD/MM/YYYY').toDate(),
        family: row[15]=='GV'?FamilyEnum.GV: FamilyEnum.SLD,
        member_type: row[16]=='Membre Actif'?MemberTypeEnum.active:MemberTypeEnum.honour,
        board_position:MemberData.boardPosition(row[17]),
        coach: false,
        gender: row[18]==='H'?GenderEnum.M:GenderEnum.F,
        birthdate: moment(row[19], 'DD/MM/YYYY').toDate()
      });
    }
}
export enum SourceEnum{
  old="old", new="new"
};

export enum FamilyEnum{
  GV="GV", SLD="SLD"
};

export enum MemberTypeEnum{
  active="active", honour="honour", coach="coach"
};

export enum BoardPositionEnum{
  president="president", vicepresident="vicepresident", secretary="secretary", treasurer="treasurer", assessor="assessor"
}

export enum PaymentEnum{
  adult="adult", apa="apa", teen="teen", student="student", volley="volley", honour="honour", committee="committee", coach="coach"
}

export enum PaymentTypeEnum{
  cheque="cheque", cash="cash", payassoc="payassoc"
}

export enum GenderEnum{
  M="M", F="F"
}

export const SOURCE_NAMES = new Map<SourceEnum, string>([
  [SourceEnum.old, 'Ancien'],
  [SourceEnum.new, 'Nouveau'],
]);

export const FAMILY_NAMES = new Map<FamilyEnum, string>([
  [FamilyEnum.GV, 'GV'],
  [FamilyEnum.SLD, 'SLD'],
]);

export const MEMBER_TYPE_NAMES = new Map<MemberTypeEnum, string>([
  [MemberTypeEnum.active, 'Membre actif'],
  [MemberTypeEnum.honour, 'Membre d\'honneur'],
]);

export const BOARD_POSITION_NAMES = new Map<BoardPositionEnum, string>([
  [BoardPositionEnum.president, 'Président'],
  [BoardPositionEnum.vicepresident, 'Vice Président'],
  [BoardPositionEnum.secretary, 'Secrétaire'],
  [BoardPositionEnum.treasurer, 'Trésorier'],
  [BoardPositionEnum.assessor, 'Assesseur'],
]);

export const PAYMENT_NAMES = new Map<PaymentEnum, string>([
  [PaymentEnum.adult, 'Adulte'],
  [PaymentEnum.apa, 'APA'],
  [PaymentEnum.teen, 'Ado'],
  [PaymentEnum.student, 'Etudiant'],
  [PaymentEnum.volley, 'Volley'],
  [PaymentEnum.honour, 'Membre d\'honneur'],
  [PaymentEnum.committee, 'Comité'],
  [PaymentEnum.coach, 'Annimateur'],
]);

export const PAYMENT_TYPE_NAMES = new Map<PaymentTypeEnum, string>([
  [PaymentTypeEnum.cheque, 'Chèque'],
  [PaymentTypeEnum.cash, 'Espèce'],
  [PaymentTypeEnum.payassoc, 'Payassoc'],
]);

export const GENDER_NAMES = new Map<GenderEnum, string>([
  [GenderEnum.M, 'H'],
  [GenderEnum.F, 'F'],
]);
